export const getFileMimeType = (fileLongName: string) => {
  const fileExtension = fileLongName.split('.').pop();
  let mimeType = '';

  switch (fileExtension) {
    case 'doc':
      mimeType = 'application/msword';
      break;
    case 'docx':
      mimeType =
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'pdf':
      mimeType = 'application/pdf';
      break;
    case 'tif':
    case 'tiff':
      mimeType = 'image/tiff';
      break;

    default:
      break;
  }
  return mimeType;
};
